module.exports = __webpack_public_path__ + "img/WLGHZX_1.f392fc23.jpg";